exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-nft-js": () => import("./../../../src/pages/nft.js" /* webpackChunkName: "component---src-pages-nft-js" */)
}

